import { createSelector } from 'reselect'
import RootState from 'store/state'

export const selectAgentsState = (state: RootState) => state.agents

export const selectPhoneBook = createSelector(selectAgentsState, (agent) => agent?.openPhonebook)
